import React, { memo } from 'react';
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  alert: {
    width: '720px',
    whiteSpace: 'pre-wrap',
    padding: '6px 14px 6px 16px',
  },
  alertAction: {
    padding: '0px 0px 0px 16px',
    alignItems: 'center',
  },
}));

type Props = SnackbarProps;

const NomalSnackbar: React.FC<React.PropsWithChildren<Props>> = memo((props) => {
  const { classes } = useStyles();
  const {
    open,
    message,
    anchorOrigin = { vertical: 'top', horizontal: 'center' },
    autoHideDuration = 5000,
    onClose,
    action,
  } = props;

  const handleAlertClose: (event: React.SyntheticEvent) => void = (event) => {
    if (onClose) onClose(event, 'clickaway');
  };

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={open}
      onClose={onClose}
      message={message}
      key={anchorOrigin.vertical + anchorOrigin.horizontal}
      autoHideDuration={autoHideDuration}
      action={action}>
      <Alert
        elevation={6}
        classes={{
          action: classes.alertAction,
        }}
        className={classes.alert}
        variant="filled"
        severity="error"
        onClose={handleAlertClose}>
        {message}
      </Alert>
    </Snackbar>
  );
});

export default NomalSnackbar;
